import CryptoJS  from 'crypto-js';


const SKEY = process.env.REACT_APP_API_KEY;

const keyHex = CryptoJS.SHA256(SKEY).toString().substring(0,32); // Fix 1: Truncate the key to 32 bytes
const ivHex = CryptoJS.SHA256(SKEY).toString().substring(0, 16);
const key = CryptoJS.enc.Utf8.parse(keyHex); // Fix 2: Convert key and IV to a WordArray using the UTF8 encoder
const iv = CryptoJS.enc.Utf8.parse(ivHex); 

// console.log(key.toString(CryptoJS.enc.Utf8));
// console.log(iv.toString(CryptoJS.enc.Utf8));

export function aesEncrypt(data) {
    let cipher = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    // return btoa(cipher.toString()); 
    return (cipher.toString()); 
}

export function aesDecrypt(data) {
    let cipher = CryptoJS.AES.decrypt(atob(data), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return cipher.toString(CryptoJS.enc.Utf8);
}


export function enCrypt(props) {

    var encryp = CryptoJS.AES.encrypt(
        props,
        key,
        { iv: iv }
    );
    return (encryp.toString())
}

export  function deCrypt(props) {
    var decryp = CryptoJS.AES.decrypt(
        props,
        key,
        { iv: iv }
    );
     return (decryp.toString(CryptoJS.enc.Utf8))
}

export function enSHA3(props) {
    var hash = CryptoJS.SHA3(props);

    return hash.toString(CryptoJS.enc.Base64);

}

export function enHMAC_SHA256(props) {
    var hash = CryptoJS.HmacSHA256(props, SKEY);

    return hash.toString(CryptoJS.enc.Base64);

}

export function enSHA256(props) {
    var hash = CryptoJS.SHA256(props);

    return hash.toString(CryptoJS.enc.Base64);

}


export function enMD564() {
    var hash = CryptoJS.MD5(SKEY);

    return hash.toString(CryptoJS.enc.Base64);

}



